import {DomainObject} from 'shared/store';
import {observable, action} from 'mobx';
import _ from 'lodash';
import User from 'main/stores/users/User';

class InterviewSchedule extends DomainObject {
  @observable templateName;
  @observable calendarEventName;
  @observable eventDescription;
  @observable duration;
  @observable location;
  @observable emailSubject;
  @observable emailRichText;
  @observable emailLexicalState;
  @observable relativeEndDateUnit;
  @observable relativeEndDateValue;
  @observable minimumNoticeValue;
  @observable minimumNoticeUnit;
  @observable eventBuffer;
  @observable availabilityWindows;
  @observable interviewers = [];
  @observable eventHost;
  @observable configuredAt;
  @observable resolvedStartDate;
  @observable resolvedEndDate;

  @action merge(other) {
    super.merge(other, {
      _dates: ['resolvedStartDate', 'resolvedEndDate'],
      interviewers: [User],
      eventHost: User
    });
  }

  @action addInterviewer(user) {
    this.interviewers.push(user);
  }

  @action removeInterviewer(user) {
    _.remove(this.interviewers, {id: user.id});
  }
}

export default InterviewSchedule;
